import { useState } from 'react'
import { Form, Input, Button, Card, Typography, message } from 'antd'
import { UserOutlined, LockOutlined } from '@ant-design/icons'
import { GoogleLogin } from '@react-oauth/google'
import { useAuth } from '../contexts/AuthContext'
import { useNavigate } from 'react-router-dom'

const { Title, Text, Link } = Typography

function LoginPage() {
  const [loading, setLoading] = useState(false)
  const [showAdmin, setShowAdmin] = useState(false)
  const { login, loginWithGoogle } = useAuth()
  const navigate = useNavigate()

  const onFinish = async (values) => {
    setLoading(true)
    const success = await login(values.username, values.password)
    setLoading(false)
    if (success) {
      navigate('/')
    }
  }

  const handleGoogleSuccess = async (credentialResponse) => {
    const credential = credentialResponse?.credential
    if (!credential) {
      message.error('Google sign-in did not return a credential')
      return
    }
    const success = await loginWithGoogle(credential)
    if (success) {
      navigate('/')
    }
  }

  return (
    <div
      style={{
        height: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        background: '#f0f2f5'
      }}
    >
      <Card style={{ width: 400 }}>
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <Title level={2} style={{ marginBottom: 4 }}>EMEW PO Integration</Title>
          <Title level={5} type="secondary" style={{ marginTop: 0 }}>
            Sign in to continue
          </Title>
        </div>

        {/* Primary: Google sign-in */}
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <GoogleLogin
            onSuccess={handleGoogleSuccess}
            onError={() => message.error('Google sign-in failed')}
            useOneTap={false}
            width="300"
          />
        </div>

        {/* Secondary: admin password login, hidden behind a small link */}
        <div style={{ textAlign: 'center', marginTop: 24 }}>
          {!showAdmin ? (
            <Link onClick={() => setShowAdmin(true)} style={{ fontSize: 13 }}>
              Admin login
            </Link>
          ) : (
            <div style={{ marginTop: 8, textAlign: 'left' }}>
              <Form name="login" initialValues={{ username: 'admin' }} onFinish={onFinish}>
                <Form.Item
                  name="username"
                  rules={[{ required: true, message: 'Please input your username!' }]}
                >
                  <Input prefix={<UserOutlined />} placeholder="Username" size="large" />
                </Form.Item>
                <Form.Item
                  name="password"
                  rules={[{ required: true, message: 'Please input your password!' }]}
                >
                  <Input.Password prefix={<LockOutlined />} placeholder="Password" size="large" />
                </Form.Item>
                <Form.Item style={{ marginBottom: 8 }}>
                  <Button type="primary" htmlType="submit" loading={loading} block size="large">
                    Log in
                  </Button>
                </Form.Item>
              </Form>
              <div style={{ textAlign: 'center' }}>
                <Link onClick={() => setShowAdmin(false)} style={{ fontSize: 13 }}>
                  Back
                </Link>
              </div>
            </div>
          )}
        </div>
      </Card>
    </div>
  )
}

export default LoginPage
